<!-- DEPRECATED -->

<template>
  <div
    :key="contact.id"
    class="info-list">
    <div class="user-info-box clearfix">
      <div class="profile">
        <div class="profile-img float-left">
          <img
            :src="`/static/img/avatars/user-chat-icon-${contact.avatar}.svg`"
            class="img-responsive rounded-circle">
        </div>
        <div class="details-main float-left">
          <input
            v-model="contact.name"
            placeholder="Add Name"
            @change="changeContactData">
          <icon name="pencil-alt"/>
          <p>{{ contact.phone }}</p>
        </div>
        <div
          v-if="$route.name === 'Chat' && contact.id"
          class="profile-link">
          <router-link
            :to="contact ? {
              name: 'ContactProfile',
              params: {
                contact_id: contact.id,
              }
            } : {}"
            target="_blank">
            <icon
              name="external-link-alt"
              height="14px"/>
          </router-link>
        </div>
      </div>
      <hr>
    </div>
    <div class="user-details">
      <div class="user-details-container scroll-area">
        <div class="pb-3 pt-1">
          <h2>Details</h2>
          <div
            v-if="contact.meta_data.country"
            class="user-details-box clearfix">
            <h4>Location</h4>
            <p><Flag :country="contact.meta_data.country.code"/>{{ contact.meta_data.country.name }}</p>
          </div>
          <div class="user-details-box clearfix">
            <h4>Status</h4>
            <span
              :class="setContactStatusClass(contact.status)"
              class="tag-item">{{ contact.status }}</span>
          </div>
          <div class="user-details-box clearfix">
            <h4>Tags</h4>
            <multiselect
              v-model="contact.tags"
              :options="contactTags"
              :multiple="true"
              :taggable="true"
              :hide-selected="true"
              :show-labels="false"
              open-direction="bottom"
              tag-placeholder=""
              placeholder="Add a tag"
              label="name"
              track-by="id"
              @search-change="findTagMatch"
              @tag="addTag"
              @input="syncTags">
              <template slot="noResult">
                <span
                  v-if="alreadySelected">
                  Start typing to add a tag.</span>
              </template>
            </multiselect>
          </div>
          <div>
            <div
              v-for="customField in customFieldList"
              :key="customField.name"
              class="user-details-box clearfix">
              <h4>{{ customField.name }}</h4>
              <CustomField
                v-model="contactCustomFields[customField.name]"
                :fieldp="customField"
                @input="syncCustomFields"/>
            </div>
          </div>
          <h2
            v-if="leads.length"
            class="mt-4">Properties</h2>
          <div class="clearfix">
            <div
              v-for="(lead, index) in leads"
              :key="index"
              class="lead-box">
              <a
                :href="lead.url"
                target="_blank">
                <p class="domain">{{ lead.domain }}</p>
                <h2 v-if="lead.property">{{ lead.property }}</h2>
                <p
                  class="message"
                  :class="{'no-message': !lead.message || lead.message === ''}">{{ lead.message || 'No message left' }}</p>
                <p class="date">{{ lead.date }}</p>
                <icon
                  name="external-link-alt"
                  height="9px"/>
              </a>
            </div>
          </div>
          <h2 class="mt-4">Notes</h2>
          <div class="user-details-box clearfix">
            <ul class="user-notes">
              <li
                v-for="(noteIndex) in filteredNotes"
                :key="noteIndex">
                <textarea-autosize
                  v-model="notes[noteIndex]"
                  :min-height="25"
                  rows="1"
                  class="edit-field"
                  placeholder="Add a note"
                  @focusout.native="updateNote"/>
              </li>
            </ul>

            <!-- TODO needs validation refactor -->
            <!-- v-validate="'required'" -->
            <textarea-autosize
              v-model="newNote"
              :min-height="30"
              :class="{ 'has-error': errors.has('add-note') }"
              name="add-note"
              rows="1"
              class="add-note"
              placeholder="Add a note"
              @focusout.native.prevent=""
              @focusout.native="addNewNote"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.user-details-container .multiselect__placeholder {
  padding-left: 0!important;
}

.lead-box {
  border-radius: 5px;
  border: 1px solid #dddddd;
  margin-top: 10px;

  &:hover {
    background: #f7f7f7;
  }

  h2 {
    margin-top: 5px!important;
  }

  a {
    padding: 8px;
    display: block;
    text-decoration: none;
    position: relative;

    .domain {
      color: $stateGray;
      font-size: 12px;
    }
    .message {
      color: $blackPrimary;
      font-size: 14px;
      white-space: pre-line;
      &.no-message {
        color: $stateGray;
      }
    }
    .date {
      color: $stateGray;
      font-size: 12px;
      color: $stateGray;
      text-align: right;
    }
    .fa-icon {
      position: absolute;
      top: 12px;
      right: 6px;
      color: $stateGray;
    }
  }
}
</style>

<script>
import { TextareaAutosize } from 'vue-textarea-autosize';
import { mapGetters, mapActions } from 'vuex';
import Multiselect from 'vue-multiselect';
import setUrl from '@/helpers/setUrl';
import CustomField from './partials/CustomField';
import Flag from '../../common/Flag';

export default {
  name: 'ContactInfo',
  components: {
    Multiselect,
    CustomField,
    TextareaAutosize,
    Flag,
  },
  props: {
    contact: {
      type: Object,
      default() {
        return {
          id: '',
          legal_name: '',
          name: '',
          platform: '',
          phone: '',
          tags: [],
        };
      },
    },
  },
  data() {
    return {
      newNote: '',
      notes: [],
      contactCustomFields: {},
      searchQuery: '',
      alreadySelected: false,
      notesPropertiesRegex: new RegExp('Received e-mail', 'g'),
    };
  },
  computed: {
    ...mapGetters({
      contactTags: 'contact/contactTagList',
      customFieldList: 'contact/customFieldList',
      contactTagCreated: 'contact/contactTagCreated',
    }),
    organisationId() {
      return this.$route.params.organisationId;
    },
    fbLink() {
      return setUrl(this.contact.meta_data.facebook_link);
    },
    twitterLink() {
      return setUrl(this.contact.meta_data.twitter_link);
    },
    whatsappUrl() {
      const phone = this.contact.phone.replace(/\D+/g, '');
      return `https://wa.me/${phone}`;
    },
    /** Matches lead notes added via SMS. */
    leads() {
      return this.notes.filter(note => note.match(this.notesPropertiesRegex))
        .map((lead) => {
          const propertyRegex = new RegExp('Property:\\s*(.*?)\\s\\n', '');
          const referenceRegex = new RegExp('Reference:\\s*([\\w\\d_]+)\\s*(?:\\n)*', '');
          const uniqueReferenceRegex = new RegExp('Unique reference:\\s*([\\w\\d_]+)\\s\\n', '');
          const urlRegex = new RegExp('URL:\\s*(http.*(www.*?)/.*?)\\s*\\n', '');
          const commentRegex = new RegExp('Comment:\\s*(?:\\")*([\\w\\W\\n]*)(?:\\")*\\s*\\n', '');
          const contactedDateRegex = new RegExp('Contacted:\\s*([\\d\\-\\s:]+)', '');

          const propertyMatch = lead.match(propertyRegex);
          const referenceMatch = lead.match(referenceRegex);
          const uniqueReferenceMatch = lead.match(uniqueReferenceRegex);
          const urlMatch = lead.match(urlRegex);
          const commentMatch = lead.match(commentRegex);
          const contactedDateMatch = lead.match(contactedDateRegex);

          return {
            property: propertyMatch ? propertyMatch[1] : undefined,
            reference: referenceMatch ? referenceMatch[1] : undefined,
            uniqueReference: uniqueReferenceMatch ? uniqueReferenceMatch[1] : undefined,
            url: urlMatch ? urlMatch[1] : undefined,
            domain: urlMatch ? urlMatch[2] : undefined,
            message: commentMatch ? commentMatch[1] : undefined,
            date: contactedDateMatch ? contactedDateMatch[1] : undefined,
          };
        });
    },
    /** Matches basic notes added by user. */
    filteredNotes() {
      return this.notes.map((note, index) => (!note.match(this.notesPropertiesRegex) ? index : null)).filter(noteIndex => noteIndex !== null);
    },
  },
  watch: {
    contact(contact) {
      this.notes = contact.meta_data.notes;
      this.contactCustomFields = contact.meta_data.custom_fields;
      this.newNote = '';
    },
    contactTagCreated(contactTag) {
      if (contactTag) {
        this.contact.tags.push(contactTag);
        this.syncTags();
      }
    },
  },
  mounted() {
    // todo: check this lists on merchant change
    if (!this.contactTags.length) {
      this.fetchContactTags({
        merchantId: this.$route.params.merchant_id,
      });
    }

    // if (!this.customFieldList.length) {
    //   this.fetchCustomFields({
    //     organisationId: this.$route.params.organisationId,
    //   });
    // }
  },
  methods: {
    ...mapActions({
      fetchContactTags: 'contact/fetchContactTags',
      // fetchCustomFields: 'contact/fetchCustomFields20',
      createContactTag: 'contact/createContactTag',
      updateContact: 'contact/updateContact',
      syncContactNotes: 'contact/syncContactNotes',
      syncContactCustomFields: 'contact/syncContactCustomFields',
      syncContactTags: 'contact/syncContactTags',
    }),
    changeContactData() {
      const contactData = {
        name: this.contact.name,
        phone: this.contact.phone,
      };

      const payload = {
        merchant_id: this.$route.params.merchant_id,
        contact_id: this.contact.id,
        organisationId: this.organisationId,
        data: contactData,
      };

      this.updateContact(payload);
    },
    syncNotes() {
      const payload = {
        organisationId: this.organisationId,
        merchant_id: this.$route.params.merchant_id,
        contact_id: this.contact.id,
        data: {
          notes: this.notes,
        },
      };

      this.syncContactNotes(payload);
    },
    syncCustomFields() {
      const fieldsToSync = {};
      Object.keys(this.contactCustomFields).forEach((key) => {
        fieldsToSync[key] = (typeof this.contactCustomFields[key] === 'undefined') ? null : this.contactCustomFields[key];
      });
      const payload = {
        organisationId: this.organisationId,
        merchant_id: this.$route.params.merchant_id,
        contact_id: this.contact.id,
        data: {
          custom_fields: fieldsToSync,
        },
      };

      this.$nextTick(() => {
        this.syncContactCustomFields(payload);
      });
    },
    syncTags() {
      const tagIds = this.contact.tags.map(tag => tag.id);

      const payload = {
        merchant_id: this.$route.params.merchant_id,
        organisationId: this.organisationId,
        contact_id: this.contact.id,
        data: {
          tags: tagIds,
        },
      };

      this.syncContactTags(payload);
    },
    addTag(newTag) {
      const payload = {
        merchant_id: this.$route.params.merchant_id,
        data: {
          name: newTag,
        },
      };

      this.createContactTag(payload);
    },
    addNewNote() {
      this.$validator.validate().then((valid) => {
        if (!valid) {
          return;
        }

        if (this.notes) {
          this.notes.push(this.newNote);
        } else {
          this.notes = [this.newNote];
        }
        this.newNote = '';
        this.$nextTick(() => {
          this.syncNotes();
        });
      });
    },
    updateNote() {
      this.notes = this.$lodash.filter(this.notes, note => note !== '');
      this.$nextTick(() => {
        this.syncNotes();
      });
    },
    setContactStatusClass(status) {
      return {
        success: status === 'subscribed',
        danger: status === 'unsubscribed',
      };
    },
    findTagMatch(searchQuery) {
      this.searchQuery = searchQuery;
      const tagNames = this.contact.tags.map(tag => tag.name.lowercase);
      this.alreadySelected = tagNames.includes(searchQuery.lowercase);
    },
  },
};
</script>
